import React from 'react';
import { Button, Glyphicon, Col, Row } from 'react-bootstrap';
import API from 'fw/system/API'
import * as FW from 'fw/system/FW'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';
import * as Modals from 'fw/globals/Modals';

library.add(faUpload);

class FileUpload extends React.Component {
    constructor(props) {
        super(props);

        let files = [];

        if (props.value !== undefined && props.value !== null && this.props.value !== "") {
            files = props.value.map((x) => {
                return {
                    storageToken: x.storageToken,
                    fileName: x.fileName,
                    size: x.size,
                    uploaded: true
                }
            })
        }

        this.state = {
            files: files,
            value: files,
            required: false,
            accept: null,
            dragOver: false
        };
    }

    // Public API
    setValue = (value) => {
        this._update(value);
    }

    getValue = () => {
        return this.state.value;
    }

    clear = () => {
        this.state.value.forEach((x, i) => this._remove(i));
    }

    focus = () => {
        this._input.focus();
    }

    select = () => {
        this._input.select();
    }

    flag = (status) => {
    }

    flagError = (status) => {
        if (!status) {
			this._fileUploadDiv.classList.add('invalid-field');
		}
		else {
			this._fileUploadDiv.classList.remove('invalid-field');
		}
    }

    validate = () => {
        return null;
    }

    completed = () => {
        let result = true;

        if (this.props.required && this.state.value.length === 0) {
            result = false;
            this.setState({ required: true });
        }

        return result;
    }

    uploadFile = (files) => {
        this.setState(
            {
                files: files,
                required: false
            }
        );
    }

    // Overwrite: Avoid value propagation, add custom handling
    _handleChange = (e) => {
        let filesRef = [];
        
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        for (let i = 0; i < this.input.files.length; i++) {
            const file = this.input.files[i];
            const sizeIndex = Math.floor(Math.log(file.size) / Math.log(1000));

            if (!this._validateFile(file, sizes, sizeIndex))
                return false;

            filesRef.push({
                fileName: file.name,
                size: parseFloat((file.size / Math.pow(1000, sizeIndex)).toFixed(2)) + ' ' + sizes[sizeIndex],
                uploaded: false,
                uploading: false,
                error: false,
                storageToken: "null",
                file: file
            });
        }

        this._updateFiles(filesRef);
    }

    _updateFiles = (filesRef) => {
        this.setState((prevState) => {
            return {
                files: prevState.files.concat(filesRef),
                required: false
            };
        }, function () {
            this.input.value = "";

            if (this.props.autoUpload)
                filesRef.forEach((f) => {
                    var index;
                    for (var i = 0; i < this.state.files.length; ++i) {
                        if (this.state.files[i].fileName === f.fileName) {
                            index = i;
                            break;
                        }
                    }
                    this._upload(f.file, index);
                });
        });
    }

    _validateFile = (file, sizes, sizeIndex) => {
        // Validate Extension
        if (this.props.accept) {
            let fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length).toLowerCase();
            
            if (!this.props.accept.toLowerCase().includes(fileExtension)) {
                this.props.onError(`The file must have one of the following file extensions: ${this.props.accept}.`);
                return false;
            }
        }

        if (this.props.maxBytes && file.size > this.props.maxBytes) {
            this.props.onError(`File size must be ${parseFloat((this.props.maxBytes / Math.pow(1000, sizeIndex)).toFixed(0)) + ' ' + sizes[sizeIndex]} or less.`);
            return false;
        }

        return true;
    }

    _handleFileDrop = (files) => {
        let filesRef = [];
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const sizeIndex = Math.floor(Math.log(file.size) / Math.log(1000));

            if (!this._validateFile(file, sizes, sizeIndex))
                return false;
            
            filesRef.push({
                fileName: file.name,
                size: parseFloat((file.size / Math.pow(1000, sizeIndex)).toFixed(2)) + ' ' + sizes[sizeIndex],
                uploaded: false,
                uploading: false,
                error: false,
                storageToken: "null",
                file: file
            });
        }

        this._updateFiles(filesRef);
    }

    _update = (value, parsed, formatted) => {
        this.setState({ value: value, display: formatted }, function () {
            const requiredPassed = this.completed();
            const validationPassed = (this.validate() === null);
            const status = requiredPassed && validationPassed;

            // Show error status if neccesary
            this.flag(status);

            // Trigger standard onChange...
            this.props.onChange && this.props.onChange(value);

            // If managed by forms, trigger field change
            if (this.props.managed)
                this.props.onFieldChange(value, this.props.name);
        });
    }

    _download(file) {
		if (this.props.useEncryption) {
			new API().downloadEncrypted({
				storageToken: file.storageToken,
				fileName: file.fileName,
				useEncryption: true,
			});
        }
        else {
			new API().download({
				storageToken: file.storageToken,
				fileName: file.fileName,
				useEncryption: false,
			});
        }
    }

    dragOver = (e) => {
        e.preventDefault();
        this.setState(
            {
                dragOver: true
            }
        );
    }
    
    dragEnter = (e) => {
        e.preventDefault();
    }
    
    dragLeave = (e) => {
        e.preventDefault();
        this.setState(
            {
                dragOver: false
            }
        );
    }
    
    fileDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        
        if (!this.props.multiple && files.length > 1)
            this.props.onError("You can only drop one file.");
        else if (!this.props.multiple && (files.length > 1 || this.state.files.length > 0))
            this.props.onError("Please remove current file first.");
        else
            this._handleFileDrop(files);

        this.setState(
            {
                dragOver: false
            }
        );
    }

    _upload(file, index) {
        this.setState((prevState) => {
            let newFiles = prevState.files.slice();
            newFiles[index].uploading = true;
            newFiles[index].error = false;
            newFiles[index].useEncryption = this.props.useEncryption;

            return {
                files: newFiles
            }
        }, function () {
            let formData = new FormData();
            formData.append("postedFiles", file);

            var url = FW.getSettings().fileUploadUrl + '/' + this.props.folder;

            if (this.props.useEncryption)
                url = FW.getSettings().fileUploadEncryptedUrl + '/' + this.props.folder;
                                       
            new API().upload(url, formData,
                {
                    success: (r) => {
                        this.setState((prevState) => {
                            let newFiles = prevState.files.slice();

                            newFiles[index].uploaded = true;
                            newFiles[index].uploading = false;
                            newFiles[index].storageToken = r.data.responses[0].storageToken;

                            // Don't know why is this happening...
                            let value = prevState.value || [];

                            return {
                                files: newFiles,
                                value: value.push(r.data.responses[0].storageToken),
                                required: newFiles.some((f) => { return f.uploaded === false })
                            };
                        });

                        const storageTokens = this.state.files.map((f) => {
                            return {
                                fileName: f.fileName,
                                storageToken: f.storageToken
                            }
                        });

                        this._update(storageTokens, storageTokens, storageTokens);

                        if (this.props.onFileUploaded)
                            this.props.onFileUploaded(storageTokens);
                    },
                    exception: (r) => {
                        this.setState((prevState) => {
                            let newFiles = prevState.files.slice();

                            newFiles[index].uploading = false;
                            newFiles[index].error = true;

                            return {
                                files: newFiles
                            };
                        });

                        if (this.props.onError)
                            this.props.onError(r.error);
                    }
                });
        });
    }

    _remove(index) {
        if (!this.props.skipConfirmation) {
            const msg = this.props.confirmationMsg;
            if (this.state.files[index])
                Modals.confirm(msg, () => this.actualRemove(index));
        } else {
            this.actualRemove(index);
        }
    }

    actualRemove(index) {
        this.setState((prevState) => {
            return {
                files: prevState.files.filter((_, i) => i !== index)
            };
        }, function () {
            const storageTokens = this.state.files.map((f) => {
                return f.storageToken;
            });

            this.props.onRemove && this.props.onRemove();

            this._update(storageTokens, storageTokens, storageTokens);
        });
    }

    // React
    shouldComponentUpdate(nextProps, nextState) {
        return nextState.files !== this.state.files ||
            nextProps.value !== this.state.value ||
            nextState.required !== this.state.required;
    }

    renderStatusGlyphicon(f) {
        let statusClass = this.props.required ? "asterisk required" : "";
        let statusStyle = 
        {
            marginRight:"7px"
        }
        let statusTitle = "";

        if (f.uploading)
        {
            statusClass = "arrow-up slide";
            statusTitle = "Uploading...";
        }

        if (f.error)
        {
            statusClass = "remove-sign error";
            statusStyle = 
            {
                marginRight:"7px",
                color:"red"
            }
            statusTitle = "Upload Error";
        }

        if (f.uploaded){
            statusClass = "ok";
            statusTitle = "Uploaded Successfully";
        }

        return(
            <div className="fileUpload__list__item__status">
                <Glyphicon style={statusStyle} title={statusTitle} glyph={statusClass} />
            </div>
        );
    }

    render() {

        const opts = {
            multiple: this.props.multiple || false,
            disabled: this.props.disabled || (this.props.multiple === true) ? false : this.state.files.length > 0,
            onChange: this._handleChange
        };

        const dragOverStyle =
        {
            borderColor: "blue",
            borderStyle: "dashed",
            WebkitBoxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(31,55,97, 0.6)",
            boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(31,55,97, 0.6)"
        };

        const dragLeaveStyle =
        {
            borderColor:"#2f528f"
        };

        const browse = this.props.multiple || this.state.files.length === 0;
        const requiredClassName = (this.props.required && this.state.required) ? "required" : "";

        const fileList = this.state.files.map((f, i) => {
            let wrappedFileName = f.fileName;
            if (f.fileName.length > this.props.wrapFileNameLength)
                wrappedFileName = f.fileName.slice(0,(this.props.wrapFileNameLength-4)) + "..." + f.fileName.slice(-4);

            return (
                <div key={f.fileName + i} className="fileUpload__list__item" style={{ boder: "solid 1px black" }}>
                    <div className={!f.uploaded ? requiredClassName : undefined}>
                        {!f.uploaded && 
                            <Row>
                                <Col xs={11} style={{ textAlign:"left", paddingRight: "0px" }}>
                                    <p style={{margin:0}} title={f.fileName}>
                                        {wrappedFileName}
                                    </p>
                                </Col>
                                <Col xs={1} style={{ paddingLeft: "0px", textAlign:"right" }}>
                                    {this.renderStatusGlyphicon(f)}
                                </Col>
                            </Row>
                        }
                        {f.uploaded && 
                            <Row>
                                <Col xs={!this.props.disabled ? 11 : 12} style={{ paddingRight: "0px", textAlign:"left" }}>
                                    <a title={f.fileName} style={{ cursor:"pointer" }} onClick={() => this._download(f)} alt="Download">
                                        {wrappedFileName}
                                    </a>
                                    &nbsp;{f.size && `(${f.size})`}
                                </Col>
                                {!this.props.disabled &&
                                    <Col xs={1} style={{ paddingLeft: "0px", textAlign:"right" }}>
                                        <a className="fileUpload__list__item__link" onClick={() => this._remove(i)}>
                                            <Glyphicon glyph="remove" disabled={opts.disabled} />
                                        </a>
                                    </Col>
                                }
                            </Row>
                        }
                    </div>
                </div >
            );
        });

        return (
            <div className="input-group" style={{ width: "100%" }}>
                <div style={this.state.dragOver ? dragOverStyle : dragLeaveStyle}
                    className="fileUpload"
                    onDragOver={this.dragOver}
                    onDragEnter={this.dragEnter}
                    onDragLeave={this.dragLeave}
                    onDrop={this.fileDrop}
                    ref={(ref) => { this._fileUploadDiv = ref }}>
                    {this.props.disabled ?
                        <div className="fileUpload__list">
                            {fileList}
                            {!this.props.multiple && this.state.files.length === 0 &&
                                <span style={{ color: "#AAA" }}>{this.props.placeholder}</span>
                            }
                        </div>
                        :
                        <div style={{textAlign:"right"}} className="fileUpload__list">
                            {fileList}
                            {browse &&
                                <div key="fileUploadItem" className="fileUpload__list__item" style={{ boder: "solid 1px black" }}>
                                    <Button 
                                        name="btnUpload" 
                                        type="button" 
                                        className={this.props.buttonClassName}
                                        bsStyle={this.props.bsStyle}
                                        disabled={this.props.disabled}
                                        onClick={() => this.input.click()}>
                                            Select File
                                    </Button>
                                    {(this.props.multiple || this.state.files.length === 0) &&
                                        <span className="fileUpload__dragDropHint" style={{ paddingRight:"5px", color: "#AAA" }}>
                                            {this.props.multiple
                                                ? <b><em>Or Drag & Drop Files Here</em></b>
                                                : <b><em>Or Drag & Drop File Here</em></b>
                                            }
                                        </span>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <input {...opts} type="file" accept={this.props.accept} className="sr-only" ref={(input) => { this.input = input; }} />
            </div>


        );
    }
}

export default FileUpload;

FileUpload.defaultProps = {
    formControl: true,
    managed: false,
    autoUpload: true,
    buttonClassName: "pull-left btn-xs",
    bsStyle: "primary",
    placeholder: "Click here to upload the relevant document",
    wrapFileNameLength: 50,
    useEncryption: false,
    confirmationMsg: "You are about to remove this document from the Application.<br /><br />If you wish to keep this document, please select 'No' and you will be returned to the previous screen.<br /><br />If you wish to Discard this document, select 'Yes'."
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/fileUpload/FileUpload.js